import { queryOptions, useQuery } from "@tanstack/react-query";
import { ErrorModal } from "@/lib/api";
import {
  getBalanceTopupPaymentKey,
  getPaymentFromSessionStorage,
  PaymentType,
} from "@/features/payment/utils";
import { api } from "@/lib/server";
import { useMuiModal } from "@/components/modal";
import { mapCashPaymentStatus } from "@/features/payment/cash-payment-status";
import { useLocation } from "@tanstack/react-router";

export function usePaymentStatus(
  payment?: PaymentType,
  // defaults to polling only on the cash screens' routes
  options?: { enabled?: boolean },
) {
  const { showModal } = useMuiModal();
  const location = useLocation();
  const paymentKey =
    payment?.kioskPaymentNonceKey ??
    getPaymentFromSessionStorage()?.kioskPaymentNonceKey ??
    getBalanceTopupPaymentKey() ??
    undefined;

  const query = useQuery(
    queryOptions({
      queryKey: ["cash-payment-status", paymentKey],
      queryFn: async ({}) => {
        if (!paymentKey) {
          throw new Error("Missing cash payment key");
        }

        const data = await api.paymentStatus(paymentKey);
        if (data.type === "error") {
          await showModal(
            <ErrorModal
              errorKey={data.error}
              errorDetails={data.errorDetails}
              translatedMessage={data.translatedMessage}
            />,
          );
          throw new Error(data.error);
        }
        return mapCashPaymentStatus(data.data!);
      },
      retry: 3,
      enabled:
        !!paymentKey &&
        (options?.enabled ?? location.href.includes("cash")),
      refetchInterval: (data) => {
        return !data.state.data?.sideEffects.completed ? 500 : false;
      },
    }),
  );

  return query;
}
